/* eslint-disable import/prefer-default-export */
import fetcher from '@api/fetchers/simpleFetcher';
import fetch from '@api/fetchers';
import { getHost } from '@utils/api-helper/host';

const defaultHost = getHost();

export const fetchDoubtDetailsWithoutAuth = (goalUID, doubtUID) =>
  fetcher(
    `${defaultHost}v2/doubts/learner/solutions/?add_title_and_tag=true&doubt_uid=${doubtUID}&goal_uid=${goalUID}&is_fast_doubts_flow=true`
  );

export const postReviewRequest = (doubtUID, goalUID, attachments) =>
  fetch('v2/doubts/learner/request/', {
    requestType: 'POST',
    body: {
      doubt_uid: doubtUID,
      goal_uid: goalUID,
      attachments
    }
  });

export const postSolutionWatched = (doubtUID, solutionUID, goalUID) =>
  fetch('v2/doubts/learner/watched/', {
    requestType: 'POST',
    body: {
      doubt_uid: doubtUID,
      solution_uid: solutionUID,
      goal_uid: goalUID
    }
  });

export const postFeedback = (feedbackData) =>
  fetch('v2/doubts/learner/feedback/', {
    requestType: 'POST',
    body: feedbackData
  });
